import React, { useState, useEffect } from 'react';
import './WarmWaterBoschHeatPump.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faRobot } from '@fortawesome/free-solid-svg-icons';

const config = require('../config');

const WarmWaterBoschHeatPump = ({ header, measurement, showChartPoints, addMeasurementToGraph, inputValue }) => {
  const [value, setValue] = useState(inputValue);
  const [isGraphSelected, setIsGraphSelected] = useState(false); 
  const [isAutomatic, setIsAutomatic] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {    
    setValue(inputValue);    
}, [inputValue]);

  const toggleAutomatic = () => {
    const newValue = !isAutomatic;
    setIsAutomatic(newValue);
  };

  const handleAddMeasurementToGraph = () => {
    setIsGraphSelected(!isGraphSelected);
    addMeasurementToGraph(header, showChartPoints ?? true, measurement);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);

    fetch(config.serverUrl + '/villa-bosch-heat-pump-warm-water-program', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        value: newValue
      })
    })
    .catch(error => { console.log(error); });
  };

  return (
    <div className="input-container">
      <span className="heatingon-header">{header}</span>
      <button onClick={toggleAutomatic} className="isAutomatic">
        <FontAwesomeIcon icon={faRobot} color={isAutomatic ? 'green' : 'red'} />
      </button>      
      <select value={value} onChange={handleChange} className="warmwaterdropdown">
        {!inputValue && <option value=""></option>}
        <option value="0">Off</option>
        <option value="1">Normal</option>
        <option value="5">Eco</option>
        <option value="2">Komfort</option>
      </select>
      <button onClick={handleAddMeasurementToGraph} className={isGraphSelected ? 'graph-btn-selected' : 'graph-btn'}>
        <FontAwesomeIcon icon={faChartLine} />
      </button>
    </div>
  );
};

export default WarmWaterBoschHeatPump;
